module.exports = __webpack_public_path__ + "static/media/p4.edd9e8ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p4.jpg
// module id = 138
// module chunks = 0